import React from 'react'
import { HowGoustoFoodBoxesWorkTypes } from '../../../../../types'
import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading3,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'
import closedGoustoboxMobileWebp from '../../assets/goustobox-closed-mobile.webp'
import closedGoustoboxWebp from '../../assets/goustobox-closed.webp'
import closedGoustoboxJpg from '../../assets/goustobox-closed.jpg'
import { LandingPageButton } from '../../../../../components'
import { FoodBoxPageSections, TargetUri, TrackingActions } from '../../../../../types/tracking'
import { OrderedCol } from '../OrderedCol'
import { ResponsiveImage } from '../../../../../components/ResponsiveImage'

export function MakeDinnerABreeze({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <>
      <OrderedCol
        order={5}
        display={Display.Flex}
        alignItems={AlignItems.FlexStart}
        justifyContent={JustifyContent.Center}
      >
        <Box
          paddingRight={[null, null, null, 10]}
          maxWidth={[null, null, null, '600px']}
          width="100%"
        >
          <ResponsiveImage
            mobileWebp={closedGoustoboxMobileWebp}
            desktopWebp={closedGoustoboxWebp}
            fallbackSrc={closedGoustoboxJpg}
            style={{ maxHeight: '457px' }}
            fit="cover"
            alt="Gousto box delivered at a customer’s door."
          />
        </Box>
      </OrderedCol>
      <OrderedCol order={4}>
        <Heading3>Make Dinner a Breeze (Not a Battle)</Heading3>
        <Space size={3} />
        <Body2 size={4}>
          Tired of the nightly “what’s for dinner?” panic? Let Gousto swoop in like a dinnertime
          superhero. We deliver tasty, no-fuss food boxes straight to your door—so you can skip the
          stress and serve up something delicious without breaking a sweat.
        </Body2>
        <Space size={6} />
        <Box
          display={Display.Flex}
          justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
          paddingBottom={[6, null, null, 0]}
        >
          <LandingPageButton
            startOnboarding={startOnboarding}
            sectionName={FoodBoxPageSections.FOOD_BOX_SECTION}
            target={TargetUri.SIGNUP}
            action={TrackingActions.CLICK_GET_STARTED}
          >
            Try Gousto with 50% off
          </LandingPageButton>
        </Box>
      </OrderedCol>
    </>
  )
}
